<footer class="site-footer">
  <div class="container">
    <div class="row g-4 foot-main">

      <!-- Brand -->
      <div class="col-lg-4">
        <div class="foot-brand d-flex align-items-center gap-2 mb-3">
          <img src="logo.png" alt="CradleResident Logo" width="34" height="34">
          <span class="foot-brand-name">CradleResident</span>
        </div>
        <p class="foot-tagline">La plataforma todo en uno para administración, seguridad y comunidad de tu fraccionamiento.</p>
      </div>

      <!-- Contact -->
      <div class="col-lg-4">
        <h6 class="foot-heading">Contacto</h6>
        <div class="d-flex flex-column gap-3">
          <a class="foot-contact-link d-flex align-items-center gap-2"
             [href]="'https://wa.me/' + contact.whatsappNumber" target="_blank" rel="noopener"
             aria-label="Escríbenos por WhatsApp">
            <span class="foot-icon-wrap foot-icon-wa">
              <fa-icon [icon]="faWhatsapp"></fa-icon>
            </span>
            {{ contact.whatsappDisplay }}
          </a>
          <a class="foot-contact-link d-flex align-items-center gap-2"
             [href]="'mailto:' + contact.email"
             aria-label="Envíanos un correo">
            <span class="foot-icon-wrap foot-icon-mail">
              <fa-icon [icon]="faEnvelope"></fa-icon>
            </span>
            {{ contact.email }}
          </a>
        </div>
      </div>

      <!-- Social -->
      <div class="col-lg-4">
        <h6 class="foot-heading">Síguenos</h6>
        <div class="d-flex gap-2 flex-wrap">
          <a class="foot-social" [href]="contact.social.x" target="_blank" rel="noopener" aria-label="X (Twitter)">
            <fa-icon [icon]="faXTwitter"></fa-icon>
          </a>
          <a class="foot-social" [href]="contact.social.facebook" target="_blank" rel="noopener" aria-label="Facebook">
            <fa-icon [icon]="faFacebook"></fa-icon>
          </a>
          <a class="foot-social" [href]="contact.social.instagram" target="_blank" rel="noopener" aria-label="Instagram">
            <fa-icon [icon]="faInstagram"></fa-icon>
          </a>
          <a class="foot-social" [href]="contact.social.tiktok" target="_blank" rel="noopener" aria-label="TikTok">
            <fa-icon [icon]="faTiktok"></fa-icon>
          </a>
          <a class="foot-social" [href]="contact.social.youtube" target="_blank" rel="noopener" aria-label="YouTube">
            <fa-icon [icon]="faYoutube"></fa-icon>
          </a>
        </div>
      </div>

    </div>

    <div class="foot-divider"></div>

    <div class="foot-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
      <p class="mb-0">Developed by <a class="foot-dev-link" [href]="developerUrl" target="_blank" rel="noopener"><strong>&lt;CradleCode/&gt;</strong></a></p>
      <p class="mb-0">&copy; 2024 – {{ currentYear }} CradleResident. Todos los derechos reservados.</p>
    </div>
  </div>
</footer>
